var _rect, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#recording_pause_blur_outer)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF349B"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -2,
    y: -2,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#recording_pause_blur_inner)",
      height: "100%",
      width: "100%"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 4,
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FFEBF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 2.25,
    height: 8,
    rx: 0.5,
    fill: "#FF349B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 6,
    width: 2.25,
    height: 8,
    rx: 0.5,
    fill: "#FF349B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recording_pause_blur_outer",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "recording_pause_blur_inner",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 16,
    height: 16,
    rx: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.5ddf1b2f2684430413f3bae5e451cd5f.svg";
export { ForwardRef as ReactComponent };